import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const PurchaseLinksEditor = ({
  open,
  onClose,
  amazonLink,
  setAmazonLink,
  barnesNobleLink,
  setBarnesNobleLink,
  authorWebsiteLink,
  setAuthorWebsiteLink,
  onSave,
  saving,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-xl p-6 w-full max-w-md border border-white/10">
        <h3 className="text-xl font-bold text-white mb-6 flex items-center">
          <ExternalLink className="h-6 w-6 text-amber-500 mr-2" />
          Purchase Links
        </h3>
        <div className="space-y-4">
          <div>
            <Label className="text-white mb-2 block">Amazon Link</Label>
            <Input
              type="url"
              placeholder="https://www.amazon.com/dp/..."
              value={amazonLink}
              onChange={(e) => setAmazonLink(e.target.value)}
              className="bg-white/5 border-white/10 text-white placeholder:text-gray-500"
              data-testid="edit-amazon-link"
            />
          </div>
          <div>
            <Label className="text-white mb-2 block">Barnes & Noble Link</Label>
            <Input
              type="url"
              placeholder="https://www.barnesandnoble.com/w/..."
              value={barnesNobleLink}
              onChange={(e) => setBarnesNobleLink(e.target.value)}
              className="bg-white/5 border-white/10 text-white placeholder:text-gray-500"
              data-testid="edit-barnes-noble-link"
            />
          </div>
          <div>
            <Label className="text-white mb-2 block">Author's Website Link</Label>
            <Input
              type="url"
              placeholder="https://www.authorname.com"
              value={authorWebsiteLink}
              onChange={(e) => setAuthorWebsiteLink(e.target.value)}
              className="bg-white/5 border-white/10 text-white placeholder:text-gray-500"
              data-testid="edit-author-website-link"
            />
          </div>
          <div className="flex justify-end space-x-3 pt-2">
            <Button variant="ghost" onClick={onClose} className="text-gray-400">
              Cancel
            </Button>
            <Button
              onClick={onSave}
              disabled={saving}
              className="bg-amber-600 hover:bg-amber-700"
              data-testid="save-links-btn"
            >
              {saving ? 'Saving...' : 'Save Links'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseLinksEditor;
